import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { defaultLanguage } from "constants/language";

const supportedLngs = ["uz", "ru", "en"];
const savedLanguage = localStorage.getItem("i18nextLng");

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs,
    fallbackLng: supportedLngs.includes(savedLanguage)
      ? savedLanguage
      : defaultLanguage,
    debug: true,
    detection: {
      order: ["queryString", "localStorage", "cookie"],
      caches: ["localStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
    // react: {
    //   useSuspense: false,
    //   wait: false,
    // },
  });
